// extracted by mini-css-extract-plugin
module.exports = {"userListItem":"jgp-1WiMG","content":"jgp-24WPN","avatar":"jgp-8OCDr","aligntop":"jgp-11xDl"};